import React, { useCallback, useEffect, useRef, useState } from 'react';
import ContentReflectionModal from '../components/shared/ContentReflectionModal';
import { setContentReflectionHandler, setContentReflectionOpenState } from '../utils/contentReflectionBridge';

const ContentReflectionProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [session, setSession] = useState(null);
  const sessionRef = useRef(null);
  sessionRef.current = session;

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setContentReflectionOpenState(false);
    const onDismiss = sessionRef.current?.onDismiss;
    if (typeof onDismiss === 'function') onDismiss();
  }, []);

  const handleOpen = useCallback((payload) => {
    setSession({
      contentId: payload?.contentId ?? '',
      contentTitle: payload?.contentTitle || 'this Quick Richuel',
      reflections: Array.isArray(payload?.reflections) ? payload.reflections : [],
      onReflected: typeof payload?.onReflected === 'function' ? payload.onReflected : null,
      onDismiss: typeof payload?.onDismiss === 'function' ? payload.onDismiss : null,
    });
    setIsOpen(true);
    setContentReflectionOpenState(true);
  }, []);

  useEffect(() => {
    setContentReflectionHandler(handleOpen);
    return () => {
      setContentReflectionHandler(null);
      setContentReflectionOpenState(false);
    };
  }, [handleOpen]);

  return (
    <>
      {children}
      <ContentReflectionModal
        isOpen={isOpen}
        contentId={session?.contentId || ''}
        contentTitle={session?.contentTitle || 'this Quick Richuel'}
        reflections={session?.reflections || []}
        onReflected={session?.onReflected}
        onClose={handleClose}
      />
    </>
  );
};

export default ContentReflectionProvider;
